import { slotList } from "@/Util/manifest";

export default {
  Zaposleni: {
    title: "Zaposleni",
    plural: "Zaposleni",
    labelNew: "Nov zaposleni",
    hasDeleted: true,
    hasPage: true,
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "title",
        label: "Ime i prezime",
        default: true,
          searchComponent: "SearchText",
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Osnovno",
        groups: slotList([
          {
            id: "main", priority: 0,
            cols: 12,
            fields: slotList([
              {
                id: "klijent", priority: 0,
                label: "Klijent",
                cols: 3,
              },
              {
                id: "title", priority: 0,
                label: "Ime i prezime",
                cols: 9,
              },
              // {
              //   id: "prvapomoc", priority: 0,
              //   label: "Prva pomoć",
              //   cols: 12,
              // },
            ]),
          }
        ]),
      },
    ]),
  },
  RadnoMesto: {
    title: "Radno mesto",
    plural: "Radna mesta",
    labelNew: "Novo radno mesto",
    hasDeleted: true,
    hasPage: true,
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "title",
        label: "Naziv",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "notes",
        label: "Napomene",
        default: true,
          searchComponent: "SearchText",
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Osnovno",
        groups: slotList([
          {
            id: "main", priority: 0,
            cols: 12,
            fields: slotList([
              {
                id: "klijent", priority: 0,
                label: "Klijent",
                cols: 3,
              },
              {
                id: "title", priority: 0,
                label: "Naziv",
                cols: 9,
              },
              {
                id: "trajanje", priority: 0,
                label: "Period lekraski pregled",
                cols: 12,
              },
              {
                id: "rizik", priority: 0,
                label: "Povećan rizik",
                cols: 12,
              },
              {
                id: "nocni", priority: 0,
                label: "Noćni rad",
                cols: 12,
              },
              {
                id: "obuka", priority: 0,
                label: "Obavezna obuka",
                cols: 12,
              },
              {
                id: "oftalmoloski", priority: 0,
                label: "Obavezan oftalmoloski pregled",
                cols: 12,
              },
              {
                id: "drugipregled", priority: 0,
                label: "Obavezan pregled po drugom osnovu",
                cols: 12,
              },

            ]),
          }
        ]),
      },
    ]),
  },
  Angazovanje: {
    title: "Angažovanje",
    plural: "Angažovanja",
    labelNew: "Novo angažovanje",
    hasDeleted: true,
    hasPage: true,
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "lokacija.title",
        label: "Lokacija",
        default: true,
        searchComponent: "SearchText",
      },
      {
        name: "zaposleni.title",
        label: "Zaposleni",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "radnomesto.title",
        label: "Radno mesto",
        default: true,
        searchComponent: "SearchText",
      },
      // {
      //   name: "title",
      //   label: "Naziv",
      //   default: true,
      //   searchComponent: "SearchText",
      // },
      {
        name: "pocetak",
        label: "Početak angažovanja",
        default: true,
        contentComponent: "DispDate",
      },
      {
        name: "kraj",
        label: "Kraj angažovanja",
        default: true,
        contentComponent: "DispDate",
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Osnovno",
        groups: slotList([
          {
            id: "main", priority: 0,
            cols: 12,
            fields: slotList([
              {
                id: "klijent", priority: 0,
                label: "Klijent",
                cols: 3,
              },
              {
                id: "lokacija", priority: 0,
                label: "Lokacija",
                cols: 3,
              },
              {
                id: "radnomesto", priority: 0,
                label: "Radno Mesto",
                cols: 3,
              },
              {
                id: "zaposleni", priority: 0,
                label: "Zaposleni",
                cols: 3,
              },
              // {
              //   id: "title", priority: 0,
              //   label: "Naziv",
              //   cols: 6,
              // },
              {
                id: "pocetak", priority: 0,
                label: "Početak angažovanja",
                cols: 3,
              },
              {
                id: "kraj", priority: 0,
                label: "Kraj angažovanja",
                cols: 3,
              },
            ]),
          }
        ]),
      },
    ]),
  },
  LekarskiPregled: {
    title: "Lekarski pregled",
    plural: "Lekarski pregledi",
    labelNew: "Nov lekarski pregled",
    hasDeleted: true,
    hasPage: true,
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
        searchComponent: "SearchText",
      },
      {
        name: "zaposleni.title",
        label: "Zaposleni",
        default: true,
        searchComponent: "SearchText",
      },
      {
        name: "title",
        label: "Vrsta lekarskog pregleda",
        default: true,
        searchComponent: "SearchText",
      },
      {
        name: "datum",
        label: "Datum pregleda",
        default: true,
          contentComponent: "DispDate",
      },
      {
        name: "dateNext",
        label: "Datum isteka",
        contentComponent: "DispDate",
        default: true,
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Osnovno",
        groups: slotList([
          {
            id: "main", priority: 0,
            cols: 12,
            fields: slotList([
              {
                id: "klijent", priority: 0,
                label: "Klijent",
                cols: 6,
              },
              {
                id: "zaposleni", priority: 0,
                label: "Zaposleni",
                cols: 6,
              },
              {
                id: "title", priority: 0,
                label: "Vrsta lekarskog pregleda",
                enum: [
                  {value: "Prethodni", text: "Prethodni"},
                  {value: "Periodični", text: "Periodični"},
                ],
                cols: 12,
              },
              {
                id: "datum", priority: 0,
                label: "Datum pregleda",
                cols: 3,
              },
              {
                id: "trajanje", priority: 0,
                label: "Rok (meseci)",
                cols: 3,
              },
              {
                id: "brizvestaja", priority: 0,
                label: "Broj izveštaja",
                cols: 3,
              },
              {
                id: "ocena", priority: 0,
                label: "Ocena sposobnosti",
                cols: 3,
              },
              {
                id: "mere", priority: 0,
                label: "Preduzete mere",
                cols: 12,
              },
            ]),
          }
        ]),
      },
    ]),
  },
  Obuka: {
    title: "Obuka",
    plural: "Obuke",
    labelNew: "Nova obuka",
    hasDeleted: true,
    hasPage: true,
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "zaposleni.title",
        label: "Zaposleni",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "title",
        label: "Vrsta",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "datum",
        label: "Datum obuke",
        contentComponent: "DispDate",
        default: true,
      },
      {
        name: "dateNext",
        label: "Datum isteka",
        contentComponent: "DispDate",
        default: true,
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Osnovno",
        groups: slotList([
          {
            id: "main", priority: 0,
            cols: 12,
            fields: slotList([
              {
                id: "klijent", priority: 0,
                label: "Klijent",
                cols: 6,
              },
              {
                id: "zaposleni", priority: 0,
                label: "Zaposleni",
                cols: 6,
              },
              {
                id: "title", priority: 0,
                label: "Vrsta",
                cols: 6,
                enum: [
                  {value: "Obrazac 6", text: "Obrazac 6"},
                  {value: "Rukovanje opremom", text: "Rukovanje opremom"},
                  {value: "Prva pomoć (osnovna)", text: "Prva pomoć (osnovna)"},
                  {value: "Prva pomoć (napredna)", text: "Prva pomoć (napredna)"},
                ],
              },
              // {
              //   id: "nivo", priority: 0,
              //   label: "Nivo",
              //   cols: 6,
              // },
              {
                id: "datum", priority: 0,
                label: "Datum obuke",
                cols: 3,
              },
              {
                id: "trajanje", priority: 0,
                label: "Rok (meseci)",
                cols: 3,
              },
            ]),
          }
        ]),
      },
    ]),
  },
  ZastitnaOprema: {
    title: "Lična zaštitna oprema",
    plural: "Lična zaštitna oprema",
    labelNew: "Nova lična zaštitna oprema",
    hasDeleted: true,
    hasPage: true,
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "radnomesto.title",
        label: "Radno mesto",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "title",
        label: "Naziv",
        default: true,
          searchComponent: "SearchText",
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Osnovno",
        groups: slotList([
          {
            id: "main", priority: 0,
            cols: 12,
            fields: slotList([
              {
                id: "klijent", priority: 0,
                label: "Klijent",
                cols: 6,
              },
              {
                id: "radnomesto", priority: 0,
                label: "Radno Mesto",
                cols: 6,
              },
              {
                id: "title", priority: 0,
                label: "Naziv",
                cols: 12,
              },
              {
                id: "standard", priority: 0,
                label: "Standard",
                cols: 12,
              },
              {
                id: "trajanje", priority: 0,
                label: "Rok trajanja (meseci)",
                cols: 12,
              },
            ]),
          }
        ]),
      },
    ]),
  },
  Povreda: {
    title: "Povreda",
    plural: "Povrede na radu",
    labelNew: "Nova povreda",
    hasDeleted: true,
    hasPage: true,
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "zaposleni.title",
        label: "Zaposleni",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "title",
        label: "Vrsta povrede",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "datum",
        label: "Datum",
        default: true,
          contentComponent: "DispDate",
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Osnovno",
        groups: slotList([
          {
            id: "main", priority: 0,
            cols: 12,
            fields: slotList([
              {
                id: "klijent", priority: 0,
                label: "Klijent",
                cols: 4,
              },
              {
                id: "zaposleni", priority: 0,
                label: "Zaposleni",
                cols: 4,
              },
              {
                id: "angazovanje", priority: 0,
                label: "Angazovanje",
                cols: 4,
              },
              {
                id: "title", priority: 0,
                label: "Vrsta povrede",
                // enum: [
                //   {value: "Prethodni", text: "Prethodni"},
                //   {value: "Periodični", text: "Periodični"},
                // ],
                cols: 12,
              },
              {
                id: "ocena", priority: 0,
                label: "Ocena težine povrede",
                // enum: [
                //   {value: "Prethodni", text: "Prethodni"},
                //   {value: "Periodični", text: "Periodični"},
                // ],
                cols: 12,
              },
              {
                id: "datum", priority: 0,
                label: "Datum pregleda",
                cols: 3,
              },
              // {
              //   id: "trajanje", priority: 0,
              //   label: "Rok (meseci)",
              //                cols: 3,
              // },
              // {
              //   id: "brizvestaja", priority: 0,
              //   label: "Broj izveštaja",
              //   cols: 3,
              // },
              // {
              //   id: "ocena", priority: 0,
              //   label: "Ocena sposobnosti",
              //   cols: 3,
              // },
              // {
              //   id: "mere", priority: 0,
              //   label: "Preduzete mere",
              //   cols: 12,
              // },
            ]),
          }
        ]),
      },
    ]),
  },

}
